import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import SummaryApi from "../common/index";
import { useAdmin } from "../context/adminContext";
import AWS from "aws-sdk";

AWS.config.update({
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
  region: process.env.REACT_APP_AWS_REGION,
});

const s3 = new AWS.S3();

const YatraDetailsPage = ({ itinerary }) => {
  const { admin } = useAdmin();
  const { id } = useParams();
  const [images, setImages] = useState([]);
  const [yatra, setYatra] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [mainPlace, setMainPlace] = useState("");
  const [subPlaces, setSubPlaces] = useState("");
 const [openDay, setOpenDay] = useState(null);
const [showModal, setShowModal] = useState(false);
  const [selectedYatra, setSelectedYatra] = useState(null);
  const [name, setName] = useState("");
    const [age, setAge] = useState("");
    const [mobileNo, setMobileNo] = useState("");
    const [aadharCardNo, setAadharCardNo] = useState("");
    const [address, setAddress] = useState("");
    const [apang, setApang] = useState(false);
    const [agreedTerms, setAgreedTerms] = useState(false);
     const navigate = useNavigate();

 const toggleDay = (day) => {
    setOpenDay(openDay === day ? null : day);
  };

  useEffect(() => {
    const fetchYatraDetails = async () => {
      try {
        const response = await fetch(SummaryApi.getAllYatra.url, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });
        const data = await response.json();

        if (response.ok) {
          const foundYatra = data.find((y) => y._id === id); // Find the yatra by ID
          if (foundYatra) {
            setYatra(foundYatra);
          } else {
            console.error("Yatra not found");
          }
        } else {
          console.error(data.message);
        }
      } catch (error) {
        console.error("Error fetching Yatra details:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchYatraDetails();
  }, [id]);

  const handlePrev = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? yatra.imageUrls.length - 1 : prev - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prev) =>
      prev === yatra.imageUrls.length - 1 ? 0 : prev + 1
    );
  };

  if (loading) {
  return (
    <div className="p-4 mt-16 max-w-6xl mx-auto">
      {/* Banner Skeleton */}
      <div className="w-full h-64 md:h-56 bg-gray-300 animate-pulse rounded-md mb-6" />

      {/* Image Slider Skeleton */}
      <div className="w-full h-96 bg-gray-300 animate-pulse rounded-md mb-6" />

      {/* Description Skeleton */}
      <div className="space-y-4">
        {[...Array(3)].map((_, index) => (
          <div key={index} className="bg-gray-300 animate-pulse h-20 rounded-md" />
        ))}
      </div>
    </div>
  );
}

  if (!yatra) return <div>Yatra details not found.</div>;

  const uploadImageToS3 = async (file) => {
    const params = {
      Bucket: process.env.REACT_APP_BUCKET_NAME,
      Key: `yatra_posters/${Date.now()}_${file.name}`,
      Body: file,
      ContentType: file.type,
    };

    return new Promise((resolve, reject) => {
      s3.upload(params, (err, data) => {
        if (err) reject(err);
        else resolve(data.Location);
      });
    });
  };

  const handlePosterUpload = async () => {
    if (!images[0]) {
      alert("Please select an image.");
      return;
    }

    try {
      const uploadedUrl = await uploadImageToS3(images[0]);

      const res = await fetch(`${SummaryApi.updateYatraPhoto.url}/${id}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ poster1: uploadedUrl }),
      });

      const result = await res.json();

      if (res.ok) {
        setImages([]);
        alert("Poster uploaded successfully.");
      } else {
        alert(result.message || "Failed to upload poster");
      }
    } catch (err) {
      console.error(err);
      alert("Error uploading image");
    }
  };

  const handleImageDownload = async () => {
    try {
      const response = await fetch(yatra.poster1);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "yatra-poster.jpg";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  const handleAddDescription = async () => {
    const description = { mainPlace, subPlaces: subPlaces.split(",") };

    try {
      const response = await fetch(`${SummaryApi.addYatraDescription.url}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: id, description }),
      });
      const data = await response.json();
      if (response.ok) {
        alert("Description added successfully");
      } else {
        alert(data.message || "Failed to add description");
      }
    } catch (error) {
      console.error(error);
      alert("Error adding description");
    }
  };

   const handleBookNow = (yatra) => {
    setYatra(yatra);
    setShowModal(true);
  };

   const resetForm = () => {
    setName("");
    setAge("");
    setMobileNo("");
    setAadharCardNo("");
    setAddress("");
    setApang(false);
    setAgreedTerms(false);
    setYatra(null);
    setShowModal(false);
  };

    const handleSubmit = async (e) => {
      e.preventDefault();
  
      const data = {
        name,
        age,
        mobileNo,
        aadharCardNo,
        address,
        yatraId: yatra._id,
        yatraName: yatra.yatraName,
        price: yatra.pricePerPerson,
        apang,
        agreedTerms,
      };
  
      try {
        const res = await fetch(SummaryApi.createVarkari.url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        });
  
        if (res.ok) {
          alert("नोंदणी यशस्वी!");
          resetForm(); 
           navigate("/");
        } else {
          const errData = await res.json();
          alert("नोंदणी अयशस्वी: " + (errData.message || "त्रुटी आली आहे."));
        }
      } catch (err) {
        console.error("Submit error:", err);
        alert("नोंदणी अयशस्वी!");
      }
    };

  return (
    <div>
      {/* Top Banner */}
      <div className="relative h-64 md:h-56 w-full mt-16">
        <img
          src={yatra.imageUrls[0]}
          alt="Yatra Banner"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/50 flex items-center justify-center">
          {yatra?.yatraName && (
            <h1 className="text-white text-2xl md:text-5xl text-center leading-relaxed my-6 font-yatra font-normal">
              {yatra.yatraName
                .split(" ")
                .reduce((acc, word, i) => {
                  const chunkIndex = Math.floor(i / 8);
                  if (!acc[chunkIndex]) acc[chunkIndex] = [];
                  acc[chunkIndex].push(word);
                  return acc;
                }, [])
                .map((line, index) => (
                  <div key={index} className="mt-4">
                    {line.join(" ")}
                  </div>
                ))}
            </h1>
          )}
        </div>
      </div>

      {/* Content Section */}
      <div className="max-w-6xl mx-auto p-4 grid grid-cols-1 md:grid-cols-10 gap-6 mt-8">
        {/* Left Column */}
        <div className="md:col-span-7">
          {/* Image Slider */}
          <div className="relative w-full h-64 md:h-96 overflow-hidden rounded-md shadow-md">
            {yatra.imageUrls.length > 0 && (
              <img
                src={yatra.imageUrls[currentIndex]}
                alt="Yatra"
                className="w-full h-full object-cover transition duration-300"
              />
            )}
            {/* Navigation Buttons */}
            {yatra.imageUrls.length > 1 && (
              <>
                <button
                  onClick={handlePrev}
                  className="absolute left-2 top-1/2 -translate-y-1/2 bg-white/70 p-2 rounded-full shadow hover:bg-white"
                >
                  ⬅
                </button>
                <button
                  onClick={handleNext}
                  className="absolute right-2 top-1/2 -translate-y-1/2 bg-white/70 p-2 rounded-full shadow hover:bg-white"
                >
                  ➡
                </button>
              </>
            )}
          </div>

          {admin && (
           <div className="space-y-4 p-4 bg-white shadow-md rounded-md">
  <h2 className="text-lg font-semibold">यात्रेचे वर्णन जोडा</h2>
  <input
    type="text"
    value={mainPlace}
    onChange={(e) => setMainPlace(e.target.value)}
    placeholder="मुख्य स्थान"
    className="w-full p-2 border border-gray-300 rounded"
  />
  <input
    type="text"
    value={subPlaces}
    onChange={(e) => setSubPlaces(e.target.value)}
    placeholder="उप-स्थाने (स्वल्पविरामाने वेगळी करा)"
    className="w-full p-2 border border-gray-300 rounded"
  />
  <button
    onClick={handleAddDescription}
    className="px-4 py-2 bg-orange-600 text-white rounded"
  >
    वर्णन जोडा
  </button>
</div>

          )}

          <div className=" mt-8">
            {/* Yatra Description Section */}
            <div className="bg-white p-6 rounded-md shadow-md">
              <h2 className="text-2xl font-bold text-orange-600 mb-4">
                मुख्य आकर्षण
              </h2>

              <div className="space-y-4">
                {yatra.description?.map((desc, index) => (
                  <div
                    key={index}
                    className="grid grid-cols-1 md:grid-cols-2 gap-4 border-b pb-4 mb-4"
                  >
                    <div className="text-lg font-medium text-gray-800">
                      <span className="text-orange-600 font-semibold"></span>{" "}
                      {desc.mainPlace}:
                    </div>
                    <div className="text-sm text-gray-700">
                      {desc.subPlaces.join(", ")}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

        {Array.isArray(yatra.itinerary) && yatra.itinerary.length > 0 && (
  <>
    <div className="mt-8 bg-white p-6 rounded-md shadow-md">
      <h2 className="text-2xl font-bold mb-4 text-orange-600">दिवसानुसार प्रवासाचे नियोजन</h2>
      {yatra.itinerary
        .sort((a, b) => a.dayNumber - b.dayNumber)
        .map((item) => (
          <div key={item.dayNumber} className="border border-gray-300 rounded mb-2">
            <button
              onClick={() => toggleDay(item.dayNumber)}
              className="w-full text-left px-4 py-2 bg-blue-100 hover:bg-blue-200 font-semibold"
            >
              दिवस {item.dayNumber}
            </button>
            {openDay === item.dayNumber && (
              <div className="px-4 py-3 bg-white">
                <h3 className="text-lg font-semibold">{item.title}</h3>
                <p className="text-sm text-gray-700">{item.description}</p>
              </div>
            )}
          </div>
        ))}
    </div>
  </>
)}



          {/* नियम व अटी */}
          {/* नियम व अटी */}
          <div className="mt-8 bg-white p-6 rounded-md shadow-md">
            <h2 className="text-2xl font-bold text-orange-600 mb-4">
              नियम व अटी:
            </h2>
           {admin ? (
  <div className="space-y-4">
    <textarea
      value={yatra.rulesAndGuidelines || ""}
      onChange={(e) =>
        setYatra((prev) => ({
          ...prev,
          rulesAndGuidelines: e.target.value,
        }))
      }
      rows={6}
      className="w-full p-2 border border-gray-300 rounded"
      placeholder="नियम व अटी येथे लिहा..."
    />
    <button
      onClick={async () => {
        try {
          const response = await fetch(SummaryApi.updateYatraRules.url, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({id: id,
              rulesAndGuidelines: yatra.rulesAndGuidelines,
            }),
          });
          const data = await response.json();
          if (response.ok) {
            alert("नियम व अटी जतन केल्या गेल्या.");
          } else {
            alert(data.message || "जतन करण्यात अडचण आली.");
          }
        } catch (error) {
          console.error(error);
          alert("संपर्कात अडचण आली.");
        }
      }}
      className="px-4 py-2 bg-orange-600 text-white rounded"
    >
      जतन करा
    </button>
  </div>
) : (
  <div className="text-gray-700 space-y-2 text-sm">
    {yatra.rulesAndGuidelines
      ?.split(/\r?\n|\r/)
      .map((item) => item.trim())
      .filter((item) => item.length > 0)
      .map((rule, index) => (
        <p key={index}>{rule}</p>
      ))}
  </div>
)}

          </div>
        </div>

        {/* Right Column */}
        <div className="md:col-span-3 bg-white rounded-md shadow-md border border-gray-200 overflow-hidden flex flex-col">
          <div className="bg-orange-600 text-white text-center py-4 px-2">
            <h2 className="text-lg font-bold">यात्रा विवरण</h2>
          </div>

          <div className="p-4 text-sm text-gray-800 space-y-4 flex-1">
            <p>
              <span className="font-bold text-orange-600">प्रस्थान शहर:</span>{" "}
              {yatra.departureLocation}
            </p>
            <p>
              <span className="font-bold text-orange-600">
                प्रस्थान दिनांक:
              </span>{" "}
              {yatra.startDate}
            </p>
            <p>
              <span className="font-bold text-orange-600">प्रवास खर्च:</span> ₹
              {yatra.pricePerPerson}
            </p>
            <p>
              <span className="font-bold text-orange-600">प्रवास कालावधी:</span>{" "}
              {yatra.durationInDays} दिवस
            </p>

            <p className="text-orange-600 font-semibold">
              प्रति व्यक्ती ₹{yatra.pricePerPerson} भरून यात्रा बुक करा.
            </p>

            {/* Buttons */}
            <div className="flex gap-3">
              <button 
              onClick={() => handleBookNow(yatra)}
              className="flex-1 border border-orange-500 text-orange-500 hover:bg-orange-50 px-4 py-2 rounded-full transition">
                बुक करा
              </button>
              <button
                className="flex-1 border border-orange-500 text-orange-500 hover:bg-orange-50 px-4 py-2 rounded-full transition"
                onClick={handleImageDownload}
              >
                टूर डाउनलोड करा
              </button>
            </div>
            <div className="w-full mt-4">
              {yatra.poster1 ? (
                <img
                  src={yatra.poster1}
                  alt="यात्रा इमेज"
                  className="w-full object-cover"
                />
              ) : (
                admin && (
                  <div className="flex flex-col items-center justify-center border-2 border-dashed border-orange-300 py-8">
                    <p className="text-gray-600 mb-2">
                      पोस्टर उपलब्ध नाही. कृपया पोस्टर अपलोड करा.
                    </p>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) => {
                        if (e.target.files && e.target.files[0]) {
                          setImages([e.target.files[0]]);
                        }
                      }}
                    />
                    <button
                      onClick={handlePosterUpload}
                      className="mt-2 px-4 py-2 bg-orange-600 text-white rounded"
                    >
                      Upload Poster
                    </button>
                  </div>
                )
              )}
            </div>
          </div>

          {/* Vertical Image */}
        </div>
      </div>


      {showModal && yatra && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-md shadow-lg w-full max-w-2xl relative max-h-[90vh] overflow-y-auto">
            <button
              onClick={() => setShowModal(false)}
              className="absolute top-2 right-2 text-gray-600 hover:text-gray-800 text-2xl font-bold"
            >
              &times;
            </button>

            <h2 className="text-xl font-bold text-orange-700 mb-4 text-center">
              {yatra.yatraName} साठी बुकिंग फॉर्म
            </h2>

            <form
              onSubmit={handleSubmit}
              className="grid grid-cols-1 gap-4 mb-6"
            >
              <input
                type="text"
                placeholder="पूर्ण नाव"
                className="border p-2 rounded"
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <input
                type="number"
                placeholder="वय"
                className="border p-2 rounded"
                required
                value={age}
                onChange={(e) => setAge(e.target.value)}
              />
              <textarea
                placeholder="स्थायी पत्ता"
                className="border p-2 rounded"
                rows="2"
                required
                value={address}
                onChange={(e) => setAddress(e.target.value)}
              />
              <input
                type="tel"
                placeholder="मोबाईल नंबर"
                className="border p-2 rounded"
                required
                value={mobileNo}
                onChange={(e) => setMobileNo(e.target.value)}
              />
              <input
                type="text"
                placeholder="आधार कार्ड क्रमांक"
                className="border p-2 rounded"
                value={aadharCardNo}
                onChange={(e) => setAadharCardNo(e.target.value)}
              />
              <label className="flex items-center gap-2">
                <input
                  type="checkbox"
                  checked={apang}
                  onChange={(e) => setApang(e.target.checked)}
                />
                अपंग आहात का?
              </label>
              <label className="flex items-center gap-2">
                <input
                  type="checkbox"
                  checked={agreedTerms}
                  onChange={(e) => setAgreedTerms(e.target.checked)}
                  required
                />
                मी नियम व अटी वाचल्या आहेत व मान्य करतो.
              </label>

              <div className="mb-6 text-center border border-dashed border-orange-500 p-4 rounded">
                <h3 className="text-lg font-semibold text-orange-700 mb-2">
                  कृपया ₹{(yatra.bookamount)}
                   अ‍ॅडव्हान्स पेमेंट करा
                </h3>
                <img
                  src="/phonepay-qr.jpg"
                  alt="PhonePe QR Code"
                  className="mx-auto w-36 h-36 object-contain border border-gray-300"
                />
                <p className="text-sm text-green-600 mt-1">
                  📲 PhonePe नंबर: <span className="font-bold">9552982935</span>
                </p>
                <p className="text-sm text-gray-700 mt-2">
                  पेमेंट झाल्यानंतर कृपया स्क्रीनशॉट काढा आणि तो माझ्या WhatsApp
                  वर पाठवा. <br />
                  <span className="font-semibold text-red-600">
                    हे अनिवार्य आहे.
                  </span>{" "}
                  स्क्रीनशॉट मिळाल्यानंतरच पेमेंट मान्य करण्यात येईल.
                </p>
                <p className="text-sm text-blue-600 mt-1">
                  📞 WhatsApp नंबर:{" "}
                  <span className="font-bold">9552982935</span>
                </p>
              </div>

              <button
                type="submit"
                className="bg-orange-600 hover:bg-orange-700 text-white py-2 rounded font-bold"
              >
                सबमिट करा
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default YatraDetailsPage;
